module.exports = __webpack_public_path__ + "static/img/font-1.178f52ff.svg";